import React from "react";
import { NavLink } from "react-router-dom";
import assets from "../../assets/assets";
import { Calendar } from "lucide-react";
import moment from "moment";
import { IP } from '../../internalServer'
import { shortenParagraph } from "../../utils/Engagement";

function SingleGroup({ group }) {
    console.log("group", group);

    const timeHelper = (a) => {
        const dateObj = new Date(a);
        // Convert to IST by adding 5 hours and 30 minutes to UTC time
        dateObj.setUTCHours(dateObj.getUTCHours() + 5);
        dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

        const day = dateObj.getUTCDate();
        const month = dateObj.getUTCMonth() + 1;
        const year = dateObj.getUTCFullYear();
        let hours = dateObj.getUTCHours();
        const minutes = dateObj.getUTCMinutes();
        const seconds = dateObj.getUTCSeconds();

        let meridiem = "AM";
        if (hours >= 12) {
            meridiem = "PM";
            hours -= 12;
        }
        if (hours === 0) {
            hours = 12;
        }

        const outputDateString = `${year}-${month}-${day}`;
        const outputTimeString = `${hours}:${minutes}:${seconds} ${meridiem}`;
        const outputDateTimeString = `${outputDateString} ${outputTimeString}`;
        return outputDateTimeString;
    };
    return (
        <div
            className="d-flex mb-4 flex-column justify-content-center gap-4 h-100"
            style={{ width: "90%" }}
        >
            <NavLink
                className="link"
                to={`/groupWiseQuery`}
                state={{ groupId: group.id }}
            >
                <div
                    className="w-100 h-100 d-flex flex-column py-4 px-3 text-start"
                    style={{
                        borderRadius: "1rem",
                        boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
                        backgroundColor: "#fff",
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        {/* LEFT SIDE */}
                        <div className="d-flex align-items-center gap-2">
                            <img
                                className="group_profile_img"
                                src={
                                    group?.profile_picture
                                        ? IP + group?.profile_picture.replace(/^\./, "")
                                        : "/group-img/groupImg1.svg"
                                }
                                alt=""
                                onError={(e) => {
                                    e.target.src = assets.QueryImg;
                                }}
                            />
                            <div className="d-flex flex-column gap-1">
                                <span
                                    style={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        wordBreak: "break-word",
                                        width: "200px",
                                        whiteSpace: "normal",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {group?.name}
                                </span>
                                {group?.latest_query && (
                                    <span
                                        style={{
                                            fontSize: "13px",
                                            color: "#555",
                                            wordBreak: "break-word",
                                            width: "400px",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {group?.latest_query?.query}
                                    </span>
                                )}
                                <div className="d-flex align-items-center gap-2 mt-1">
                                    <Calendar size={16} />
                                    <small style={{ fontSize: "12px", color: "#444" }}>
                                        {group?.latest_query
                                            ? moment(
                                                timeHelper(group?.latest_query?.user?.created_at)
                                            ).format("D MMMM YYYY")
                                            : ""}
                                    </small>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="d-flex align-items-center flex-column gap-2">
                            {/* Class | Section | Subject */}
                            <div
                                className="px-3 py-2 rounded-3 d-flex align-items-center justify-content-between"
                                style={{
                                    backgroundColor: "#f4f4f4",
                                    width: "100%",
                                    borderRadius: "12px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                                    gap: "33px"
                                }}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: "12px", color: "#333" }}>Class</span>
                                    <span className="fw-semibold" title={group?.standard?.name}>{shortenParagraph(group?.standard?.name, 12)}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: "12px", color: "#333" }}>
                                        Section
                                    </span>
                                    <span className="fw-semibold" title={group?.section?.name}>{shortenParagraph(group?.section?.name, 10)}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: "12px", color: "#333" }}>
                                        Subject
                                    </span>
                                    <span className="fw-semibold" title={group?.subject?.name}>
                                        {shortenParagraph(group?.subject?.name, 20) || "Not Selected"}
                                    </span>
                                </div>
                            </div>

                            {/* Total | Pending Queries */}
                            <div
                                className="px-3 py-2 rounded-3 d-flex align-items-center justify-content-between"
                                style={{
                                    backgroundColor: "#f4f4f4",
                                    width: "300px",
                                    borderRadius: "12px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: "12px", color: "#333" }}>
                                        Total Queries
                                    </span>
                                    <span className="fw-semibold">{group.totalQueryCount}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: "12px", color: "#333" }}>
                                        Pending Queries
                                    </span>
                                    <span className="fw-semibold">
                                        {group.totalPendingQueries}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
        </div>
    )
}

export default SingleGroup;
